export default __webpack_public_path__ + "280a1f95a980975cbe212aab4981ebf5.png";